/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const BellDisabledSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.4 3.4a1.4 1.4 0 1 0-2.8 0v.37a.53.53 0 0 1-.38.499 6.01 6.01 0 0 0-2.967 2.06L18.924 18h.369a.707.707 0 0 0 .5-1.207l-1.5-1.5a1 1 0 0 1-.293-.707V10a6.003 6.003 0 0 0-4.22-5.731.53.53 0 0 1-.38-.5V3.4ZM16.803 18 6.47 7.668v.002L3.74 4.942a.25.25 0 0 0-.353 0l-.354.354a.25.25 0 0 0 0 .353l3.097 3.097A6.024 6.024 0 0 0 6 10v4.586a1 1 0 0 1-.293.707l-1.5 1.5a.707.707 0 0 0 .5 1.207h10.678l3.559 3.56a.25.25 0 0 0 .354 0l.353-.354a.25.25 0 0 0 0-.354L16.8 18h.004Zm-2.865 1.492c.068-.267-.162-.495-.438-.495h-3c-.276 0-.506.228-.438.495a2 2 0 0 0 3.876 0Z" /></svg>);
const BellDisabledSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={BellDisabledSolidBase} {...rest} ref={ref} />);
export default BellDisabledSolid;